// Author YuJiaBei
// Date 2020-08-07 15:55:23

import * as model from "@/model/em/lifecycle/EmLcAccInstAccRepIarModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmLcAccInstAccRepIar(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_LIFECYCLE_URL,
        callbackApi: process.env.VUE_APP_EM_LIFECYCLE_URL + '/emLcAccInstAccRepIar/workflow/complete-feedback',
        processDefinitionKey: "em_lifecycle_acceptance_report",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
